import React from "react";
import { useI18n } from "@/i18n";
import { useSettings } from "@/context/SettingsContext";
import { PaperSection, CloudDivider } from "@/components/common";
import { motion } from "framer-motion";
import { BookHeart, Sparkles, HandHeart } from "lucide-react";

export default function About() {
  const { t, lang } = useI18n();
  const { settings } = useSettings();
  const about = settings?.content?.about || {};
  const g = (base) => about[`${base}_${lang}`] || about[`${base}_zh`] || "";

  const blocks = [
    { icon: BookHeart, title: lang === "zh" ? "你好功德简介" : "About CiAO Merit", body: g("intro") },
    { icon: Sparkles, title: lang === "zh" ? "功德的意义" : "The Meaning of Merit", body: g("meaning") },
    { icon: HandHeart, title: lang === "zh" ? "一份爱心一份温暖" : "A Bit of Love, A Bit of Warmth", body: g("warmth") },
  ];

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
      <div className="text-center mb-8">
        <div className="text-xs uppercase tracking-[0.25em] text-[hsl(var(--brand-bronze))] font-semibold">ABOUT</div>
        <h1 className="mt-2 font-display text-3xl sm:text-4xl font-bold">{t("nav.about")}</h1>
        <p className="mt-2 text-muted-foreground">{t("tagline")}</p>
      </div>
      <CloudDivider />
      <div className="space-y-6 mt-6">
        {blocks.map((b, i) => (
          <motion.div key={i} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.08 }}>
            <PaperSection>
              <div className="flex items-start gap-4">
                <div className="h-11 w-11 shrink-0 rounded-xl bg-[hsl(var(--brand-gold-soft))] flex items-center justify-center">
                  <b.icon className="h-5 w-5 text-[hsl(var(--brand-bronze))]" />
                </div>
                <div>
                  <h2 className="font-display text-xl font-semibold">{b.title}</h2>
                  <p className="mt-2 text-[15px] leading-7 text-foreground/85 whitespace-pre-line">{b.body}</p>
                </div>
              </div>
            </PaperSection>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
